import React from 'react';
import cx from 'classnames';
import LoadingSpinner from './spinner/Spinner'

function GallerySlide({ isActiveSlide = false, slideNumber = 0, slideUrl = '', setActiveFrame }) {


  const handleSetActiveFrame = () => {
    setActiveFrame(slideNumber);
  }


  const slideText = isActiveSlide ? 'Current page' : `Page ${Number(slideNumber) + 1}`;

  return (
    <div
      className={cx('gallery-item', { active: isActiveSlide })}
      onClick={handleSetActiveFrame}
    >
      <div className="gallery-thumbnail-wrapper">
        <LoadingSpinner />
        <img
          src={slideUrl}
          className="gallery-thumbnail"
          alt=""
        />
      </div>
      {slideNumber !== -1
        ? <div className={cx('button', { active: isActiveSlide })}>
          {slideText}
        </div>

        : <div className="button">
          Cover
          </div>
      }
    </div>
  );

}

export default GallerySlide;


// WEBPACK FOOTER //
// ./src/components/GallerySlide.jsx